export default __webpack_public_path__ + "static/media/cas1.59bc8f41.png";